export enum CommonImageKeys {
  POWERED_BY_PERMISSO_LOGO = "powered-by-permisso-gray-logo.svg",
  AEAT_ROUNDED_LOGO = "agencia-tributaria.png",
  SEG_SOCIAL_ROUNDED_LOGO = "seguridad-social.png",
}
